import { render, staticRenderFns } from "./p31.vue?vue&type=template&id=d1591964&scoped=true&"
import script from "./p31.vue?vue&type=script&lang=js&"
export * from "./p31.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1591964",
  null
  
)

export default component.exports